export default function CardsContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-[6px] gap-y-4 sm:gap-x-2 md:gap-x-4 lg:gap-x-1 md:gap-y-6 p-2 mt-2 w-full max-w-screen-2xl md:px-[10%] lg:px-[7%]">
      {children}
    </div>
  );
}
